module.exports = __webpack_public_path__ + "static/media/Big_Cloud_Down_Red.3322502c.bmp";